<template>
  <v-container fluid class="vehicle-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/vehicle/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="vehicles-table"
              show-select
              single-select
              item-key="_id"
              sort-by="vehiclename"
              :footer-props="footer"
              :headers="headers"
              :items="vehicles"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Vehicle?
                    </v-card-title>

                    <v-card-text>
                      {{ deleteVehicle.vehiclename }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deleteVehicle)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.vehicleimage" size="35">
                  <img v-bind:src="item.vehicleimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.vehiclename[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.vehiclename="{ item }">
                <a class="primaryConst--text">{{ item.vehiclename }}</a>
              </template>
              <template v-slot:item.vehicleemail="{ item }">
                <a class="primaryConst--text">{{ item.vehicleemail }}</a>
              </template>
              <template v-slot:item.vehiclename="{ item }">
                <p class="two-line">{{ item.vehiclename  }}</p>
                <p class="two-line">{{ item.vehiclecode  }}</p>
              </template>
              <template v-slot:item.items="{ item }">
                <p class="two-line">{{ item.items.reduce((a,b) => a + (b.itemquantity), 0) }}</p>
              </template>
              <template v-slot:item.driverid="{ item }">
                <p class="two-line">{{ item.driverid!=undefined && users.find(user=>user._id == item.driverid)!=null ? users.find(user=>user._id == item.driverid)['username'] : ''   }}</p>
                <p class="two-line">{{ item.loaderid!=undefined && users.find(user=>user._id == item.loaderid)!=null ? users.find(user=>user._id == item.loaderid)['username'] : ''  }}</p>
              </template>
              <template v-slot:item.locationid="{ item }">
                <p class="two-line">{{ item.locationid!=null && locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : '' }} </p>
              </template>
              <template v-slot:item.vehiclestatus="{ item }">
                <v-chip
                  :color="item.vehiclestatus=='Active' ? 'success white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.vehiclestatus }}
                  
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'vehicleList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deleteVehicle: {},
      headers: [
        { text: 'Image', value: 'image', sortable: false },
        { text: 'Type', value: 'vehicletype' },
        { text: 'Name', value: 'vehiclename' },
        { text: 'Location', value: 'locationid' },
        { text: 'Driver-Loader', value: 'driverid' },
        { text: 'Loading', value: 'items', width: '8%'},
        { text: 'Status', value: 'vehiclestatus', width: '10%' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],  
    }
  },

  computed: {
    ...mapState("Location", ["locations"]),
    ...mapState("User", ["users"]),
    ...mapState('Vehicle', ['vehicles', 'isReceiving', 'isDeleting', 'idToDelete', 'vehiclesMessage', 'isUpdating']),
  },


  async created () {
    if(this.vehicles.length==0) await this.getVehiclesRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },

  methods: {
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    ...mapActions('Vehicle', ["getVehiclesRequest","deleteVehicleRequest","updateVehicleRequest","insertVehicleRequest"]),
    editItem(item) {
      this.$router.push({ name: 'VehicleEdit', params: item })
    },

    deleteItem(item) {

      //const pos = this.vehicles.map(function(vehicle) { return vehicle._id; }).indexOf(item._id);
      //this.vehicles.splice(pos, 1);
      this.deleteVehicleRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deleteVehicle = {
        _id: item._id,
        vehiclename: item.vehiclename,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
